import Repository from "./repository"

export default {
    /**
     * ログイン処理
     * @params パラメーター
     * @returns response
     */
    login(params) {
        return Repository.post("/api/c201-master-login/login", params)
    },
}